var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRohesartsLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -35.64,
    y1: 928.99,
    x2: 833.13,
    y2: 60.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#65bc46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58bbef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 221.6,
    y1: 692.42,
    x2: 222.64,
    y2: 692.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7bb957"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#58bbef"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M988.83,136c-151.57-27-296.75-26.79-422.4-1.49-137.25,26.25-255.2,80.45-339,156.39-85.31,77.13-139.34,175.51-150,288.48-5.75,52.77-1.92,111.52,14.79,171l9.85,38,7.65,31.11a740.88,740.88,0,0,0-35.26,120.2,20.52,20.52,0,0,0,13.57,23.59,17,17,0,0,0,2.45.65c11.14,2.29,21.58-5,24.24-16,10.88-44.95,21.79-81.68,35.19-118.54,37.65-99,97.16-199.87,183.26-294.86-12.65-2.9-69.64-10.75-126.25-12.22a4.8,4.8,0,0,1-3.61-7.84C340,351.17,568.68,273.15,649.69,249.62c4.08-1.18,6.36,4.5,2.63,6.54-75.73,41.36-164,95.76-232.89,186.25,22.65,1.52,90,6.06,173.34,19.12a4.41,4.41,0,0,1,.42,8.64c-197,49.5-345.57,246.17-393.94,367.74,323.21-1,386.91-149.91,491.54-325.07C760.61,396.78,837,270.22,997.59,169.45h0c13.93-8.94,9.55-30.34-6.77-33.09Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M222,692.46c-1.62,3,2-3.11,0,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRohesartsLogoSmall);
export default __webpack_public_path__ + "static/media/rohesarts-logo-small.33ab28dafebf3151c19ba58ae596e405.svg";
export { ForwardRef as ReactComponent };